export type LeaseLengthsProps = {
  hasFlexible: boolean;
  hasLessThanOneYear: boolean;
  hasMonthly: boolean;
  hasMoreThanOneYear: boolean;
  hasNone: boolean;
  hasOneYear: boolean;
  hasSixMonths: boolean;
};

const LeaseLengths = ({
  hasFlexible = false,
  hasLessThanOneYear = false,
  hasMonthly = false,
  hasMoreThanOneYear = false,
  hasNone = false,
  hasOneYear = false,
  hasSixMonths = false,
}: Partial<LeaseLengthsProps> = {}): LeaseLengthsProps => ({
  hasFlexible: Boolean(hasFlexible),
  hasLessThanOneYear: Boolean(hasLessThanOneYear),
  hasMonthly: Boolean(hasMonthly),
  hasMoreThanOneYear: Boolean(hasMoreThanOneYear),
  hasNone: Boolean(hasNone),
  hasOneYear: Boolean(hasOneYear),
  hasSixMonths: Boolean(hasSixMonths),
});

export default LeaseLengths;
